module.exports = __webpack_public_path__ + "static/media/mailing-icn.db8d3d29.svg";